import { alpha } from '@mui/material';

import palette from '@/theme/palette';

export const styles = {
  filter: {
    '.MuiOutlinedInput-notchedOutline': {
      borderRadius: '10px',
      backgroundColor: alpha(palette.border.default, 0.1),
      border: `1px solid ${palette.border.default}`,
    },
    '.MuiInputBase-input': {
      typography: 'subtitle2',
      fontWeight: 500,
      fontSize: '16px',
      marginLeft: '5px',
    },
    '& .MuiSvgIcon-root': {
      color: palette.text.secondary,
      height: '25px',
      width: '25px',
      marginLeft: '5px',
    },
    '& .MuiInput-underline:before, & .MuiInput-underline:hover:not(.Mui-disabled):before': {
      display: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'transparent',
    },
  },
};
